/**
 * TagsPanel.tsx - TagsPanel - Shows all tags across all notes
 * 
 * CHANGE HISTORY:
 * - 251021_0421 [7529d5e] danielbeer: feat: migrate all packages to TypeScript structure
 */
import React from 'react';

const TagsPanel = ({ tags, onTagClick }) => {
  if (!tags || tags.length === 0) {
    return null;
  }
  
  return (
    <div className="tags-panel">
      <h4>All Tags</h4>
      <div className="tags-list">
        {tags.map(tag => (
          <span
            key={tag}
            className="tag-item"
            onClick={() => onTagClick(tag)}
          >
            #{tag}
          </span>
        ))}
      </div>
    </div>
  );
};

export default TagsPanel;
